// Minimal client-side CSV export. Escapes fields that contain comma / quote / newline.

import { toast } from './toast.js';

function escape(v: unknown): string {
  if (v == null) return '';
  const s = typeof v === 'string' ? v : Array.isArray(v) ? v.join('; ') : typeof v === 'object' ? JSON.stringify(v) : String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCSV(filename: string, rows: Array<Record<string, unknown>>, headers?: Array<{ key: string; label?: string }>) {
  if (rows.length === 0 && !headers) {
    toast.warn('Nothing to export', 'No rows match the current filter');
    return;
  }
  const cols: Array<{ key: string; label?: string }> = headers ?? Object.keys(rows[0] ?? {}).map((k) => ({ key: k }));
  const lines: string[] = [];
  lines.push(cols.map((c) => escape(c.label ?? c.key)).join(','));
  for (const r of rows) {
    lines.push(cols.map((c) => escape(r[c.key])).join(','));
  }
  const blob = new Blob(['\ufeff', lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const fname = filename.endsWith('.csv') ? filename : filename + '.csv';
  a.href = url;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  toast.success('CSV Downloaded', `${fname} \u00b7 ${rows.length} row${rows.length !== 1 ? 's' : ''}`);
}
